module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBold.a2131b75.woff";